<div class="checkout-container">
    <!-- Simple Header (without cart) -->
    <div class="checkout-simple-header">
        <div class="header-content">
            <div class="logo-section">
                <img [src]="logoUrl" alt="Logo" class="logo" (click)="goToHome()" style="cursor: pointer;" />
            </div>
            <div class="header-actions">
                <!-- Countdown Timer -->
                <div *ngIf="timeRemaining && cartItems.length > 0" class="countdown-timer">
                    <svg xmlns="http://www.w3.org/2000/svg" class="timer-icon" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <span class="timer-text">{{ timeRemaining }}</span>
                </div>
                <button (click)="cancelCheckout()" class="btn-back">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M6 18L18 6M6 6l12 12" />
                    </svg>
                    Cancelar
                </button>
            </div>
        </div>
    </div>

    <!-- Event Banner -->
    @if (eventInfo) {
      <section class="border-b border-gray-300 bg-white">
        <div class="max-w-7xl mx-auto px-6 py-2">
          <div class="aspect-[16/5] bg-gray-100 border border-gray-300 overflow-hidden rounded-2xl">
            <img 
              [src]="eventInfo.imagenes?.horizontal" 
              [alt]="eventInfo.nombre"
              class="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>
      <section class="py-2 border-b border-gray-300 bg-white">
        <div class="max-w-7xl mx-auto px-6">
          <span class="inline-block mb-1 text-sm bg-gray-200 text-gray-700 px-4 py-1 rounded-full">
            {{ eventInfo.categoria }}
          </span>
          <h2 class="text-2xl font-bold text-gray-900">{{ eventInfo.nombre }}</h2>
          @if (eventInfo.lugar) {
            <div class="flex items-center space-x-2 mt-1 text-gray-600">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
              </svg>
              <span class="text-sm">{{ eventInfo.lugar }}</span>
            </div>
          }
        </div>
      </section>
    }

    <div class="checkout-content">
        <!-- Header -->
        <div class="checkout-header">
            <h1 class="checkout-title">Finalizar Compra</h1>
            <button (click)="cancelCheckout()" class="btn-cancel">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
        </div>

        <div class="checkout-grid">
            <!-- Checkout Form -->
            <div class="checkout-form" *ngIf="!selectedMetodoPago">
                <!-- Información de Contacto -->
                <div class="form-step">
                    <h2 class="section-title">Información de Contacto</h2>

                    <!-- Grid de dos columnas -->
                    <div class="form-grid">
                        <!-- Primera fila: Nombre y Apellido -->
                        <div class="form-group">
                            <label for="firstname" class="form-label">Nombre *</label>
                            <input type="text" id="firstname" [(ngModel)]="userInfo.firstname"
                                (ngModelChange)="onContactInfoChange()" (blur)="toUpperCase('firstname')"
                                [readonly]="isProfileDataLoaded" maxlength="30" class="form-input"
                                placeholder="Ingrese su nombre" />
                        </div>

                        <div class="form-group">
                            <label for="lastname" class="form-label">Apellido *</label>
                            <input type="text" id="lastname" [(ngModel)]="userInfo.lastname"
                                (ngModelChange)="onContactInfoChange()" (blur)="toUpperCase('lastname')"
                                [readonly]="isProfileDataLoaded" maxlength="30" class="form-input"
                                placeholder="Ingrese su apellido" />
                        </div>

                        <!-- Segunda fila: Email y Teléfono -->
                        <div class="form-group">
                            <label for="email" class="form-label">Correo Electrónico *</label>
                            <input type="email" id="email" [(ngModel)]="userInfo.email"
                                (ngModelChange)="onContactInfoChange()" [readonly]="isProfileDataLoaded"
                                class="form-input" [class.input-error]="userInfo.email && !isValidEmail(userInfo.email)"
                                placeholder="correo@ejemplo.com" />
                            <p *ngIf="userInfo.email && !isValidEmail(userInfo.email)" class="error-message">
                                El correo electrónico no es válido
                            </p>
                        </div>
                        <div class="form-group" *ngIf="!isProfileDataLoaded">
                            <label for="email-confirmation" class="form-label">Confirmar Correo Electrónico *</label>
                            <input type="email" id="email-confirmation" [(ngModel)]="emailConfirmation"
                                class="form-input" [class.input-error]="emailConfirmation && !emailsMatch()"
                                placeholder="Confirme su correo electrónico" />
                            <p *ngIf="emailConfirmation && !emailsMatch()" class="error-message">
                                Los correos electrónicos no coinciden
                            </p>
                        </div>

                        <div class="form-group" style="grid-column: 1 / -1;">
                            <label for="phone" class="form-label">Teléfono *</label>
                            <div class="phone-input-container">
                                <div class="country-selector" [class.readonly]="isProfileDataLoaded">
                                    <button type="button" class="country-selector-button"
                                        (click)="toggleCountryDropdown('contact'); $event.stopPropagation()" 
                                        [disabled]="isProfileDataLoaded">
                                        <span class="fi fi-{{ getSelectedCountry(selectedCountryContact)?.code?.toLowerCase() }}"></span>
                                        <span class="dial-code">{{ getSelectedCountry(selectedCountryContact)?.dialCode
                                            }}</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" class="chevron-icon" fill="none"
                                            viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M19 9l-7 7-7-7" />
                                        </svg>
                                    </button>

                                    <div class="country-dropdown" *ngIf="showCountryDropdownContact" (click)="$event.stopPropagation()">
                                        <div class="country-list">
                                            <button type="button" *ngFor="let country of countries"
                                                class="country-option" (click)="selectCountry(country, 'contact'); $event.stopPropagation()">
                                                <span class="fi fi-{{ country.code.toLowerCase() }}"></span>
                                                <span class="country-name">{{ country.name }}</span>
                                                <span class="dial-code">{{ country.dialCode }}</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <input type="tel" id="phone" [(ngModel)]="userInfo.phone"
                                    (input)="onPhoneInput('contact')" (ngModelChange)="onContactInfoChange()"
                                    [readonly]="isProfileDataLoaded" [placeholder]="getPhonePlaceholder('contact')"
                                    [maxlength]="getPhoneMaxLength('contact')"
                                    [class.input-error]="validatePhone('contact')"
                                    class="form-input phone-number-input" />
                            </div>
                            <p *ngIf="validatePhone('contact')" class="error-message">
                                {{ validatePhone('contact') }}
                            </p>
                        </div>



                    </div>
                </div>

                <!-- Información de Facturación -->
                <div class="form-step">
                    <h2 class="section-title">Información de Facturación</h2>

                    <div class="form-group">
                        <label for="billing-nombre-completo" class="form-label">Nombre Completo *</label>
                        <input type="text" id="billing-nombre-completo" [(ngModel)]="billingInfo.nombreCompleto"
                            (blur)="toUpperCase('nombreCompleto')" maxlength="30" class="form-input"
                            placeholder="Nombre completo para facturación" />
                        <p class="info-helper">Se completará automáticamente con los datos de contacto</p>
                    </div>

                    <div class="form-group">
                        <label for="billing-tipo-identificacion" class="form-label">Tipo de Identificación *</label>
                        <select id="billing-tipo-identificacion" [(ngModel)]="billingInfo.tipo_identificacion.codigo"
                            (change)="onTipoIdentificacionChange($event)" class="form-input"
                            [disabled]="isLoadingTiposId">
                            <option value="" disabled selected>Seleccione un tipo</option>
                            <option *ngFor="let tipo of tiposIdentificacion" [value]="tipo.codigo">
                                {{ tipo.descripcion }}
                            </option>
                        </select>
                        <p *ngIf="isLoadingTiposId" class="info-helper">Cargando tipos de identificación...</p>
                    </div>

                    <div class="form-group">
                        <label for="billing-identificacion" class="form-label">Número de Identificación *</label>
                        <input type="text" id="billing-identificacion" [(ngModel)]="billingInfo.identificacion"
                            class="form-input" placeholder="Número de identificación"
                            [maxlength]="getMaxLengthIdentificacion()" [class.input-error]="validateIdentificacion()" />
                        <p *ngIf="billingInfo.tipo_identificacion.codigo && !validateIdentificacion()"
                            class="info-helper">
                            {{ getTipoIdentificacionValidacion() }}
                        </p>
                        <p *ngIf="validateIdentificacion()" class="error-message">
                            {{ validateIdentificacion() }}
                        </p>
                    </div>

                    <div class="form-group">
                        <label for="billing-direccion" class="form-label">Dirección *</label>
                        <input type="text" id="billing-direccion" [(ngModel)]="billingInfo.direccion" class="form-input"
                            placeholder="Dirección completa" />
                    </div>

                    <div class="form-group">
                        <label for="billing-telefono" class="form-label">Teléfono *</label>
                        <div class="phone-input-container">
                            <div class="country-selector">
                                <button type="button" class="country-selector-button"
                                    (click)="toggleCountryDropdown('billing'); $event.stopPropagation()">
                                    <span class="fi fi-{{ getSelectedCountry(selectedCountryBilling)?.code?.toLowerCase() }}"></span>
                                    <span class="dial-code">{{ getSelectedCountry(selectedCountryBilling)?.dialCode
                                        }}</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" class="chevron-icon" fill="none"
                                        viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M19 9l-7 7-7-7" />
                                    </svg>
                                </button>

                                <div class="country-dropdown" *ngIf="showCountryDropdownBilling" (click)="$event.stopPropagation()">
                                    <div class="country-list">
                                        <button type="button" *ngFor="let country of countries"
                                            class="country-option" (click)="selectCountry(country, 'billing'); $event.stopPropagation()">
                                            <span class="fi fi-{{ country.code.toLowerCase() }}"></span>
                                            <span class="country-name">{{ country.name }}</span>
                                            <span class="dial-code">{{ country.dialCode }}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <input type="tel" id="billing-telefono" [(ngModel)]="billingInfo.telefono"
                                (input)="onPhoneInput('billing')" [placeholder]="getPhonePlaceholder('billing')"
                                [maxlength]="getPhoneMaxLength('billing')"
                                [class.input-error]="validatePhone('billing')" class="form-input phone-number-input" />
                        </div>
                        <p *ngIf="validatePhone('billing')" class="error-message">
                            {{ validatePhone('billing') }}
                        </p>
                        <p class="info-helper">Se completará automáticamente con los datos de contacto</p>
                    </div>

                    <div class="form-group">
                        <label for="billing-email" class="form-label">Email *</label>
                        <input type="email" id="billing-email" [(ngModel)]="billingInfo.email" class="form-input"
                            [class.input-error]="billingInfo.email && !isValidEmail(billingInfo.email)"
                            placeholder="Email para factura" />
                        <p *ngIf="billingInfo.email && !isValidEmail(billingInfo.email)" class="error-message">
                            El correo electrónico no es válido
                        </p>
                        <p class="info-helper">Email donde recibirás tu factura y confirmación</p>
                    </div>
                </div>

                <!-- Documentos Legales -->
                <div class="form-step" *ngIf="legalDocs">
                    <h2 class="section-title">Términos Legales</h2>

                    <!-- Términos y Condiciones -->
                    <div class="legal-section">
                        <div class="legal-header" (click)="toggleTerminos()">
                            <div class="legal-title-row">
                                <svg xmlns="http://www.w3.org/2000/svg" class="legal-icon" fill="none"
                                    viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                </svg>
                                <h3 class="legal-title">Términos y Condiciones</h3>
                                <svg xmlns="http://www.w3.org/2000/svg" [class.rotate-icon]="showTerminos"
                                    class="toggle-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M19 9l-7 7-7-7" />
                                </svg>
                            </div>
                        </div>

                        <div class="legal-content" *ngIf="showTerminos">
                            <div class="legal-text markdown-content">{{ legalDocs.terminosCondiciones }}</div>
                        </div>

                        <div class="legal-checkbox">
                            <label class="checkbox-label">
                                <input type="checkbox" [(ngModel)]="aceptaTerminos" class="checkbox-input" />
                                <span class="checkbox-text">He leído y acepto los Términos y Condiciones *</span>
                            </label>
                        </div>
                    </div>

                    <!-- Política de Datos -->
                    <div class="legal-section">
                        <div class="legal-header" (click)="togglePoliticaDatos()">
                            <div class="legal-title-row">
                                <svg xmlns="http://www.w3.org/2000/svg" class="legal-icon" fill="none"
                                    viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                </svg>
                                <h3 class="legal-title">Política de Protección de Datos</h3>
                                <svg xmlns="http://www.w3.org/2000/svg" [class.rotate-icon]="showPoliticaDatos"
                                    class="toggle-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M19 9l-7 7-7-7" />
                                </svg>
                            </div>
                        </div>

                        <div class="legal-content" *ngIf="showPoliticaDatos">
                            <div class="legal-text markdown-content">{{ legalDocs.politicaDatos }}</div>
                        </div>

                        <div class="legal-checkbox">
                            <label class="checkbox-label">
                                <input type="checkbox" [(ngModel)]="aceptaPoliticaDatos" class="checkbox-input" />
                                <span class="checkbox-text">He leído y acepto la Política de Protección de Datos
                                    *</span>
                            </label>
                        </div>
                    </div>
                </div>

                <div class="form-step">
                    <div class="button-group">
                        <button (click)="continueCheckout()" class="btn-confirm"
                            [disabled]="isLoadingMetodosPago || !canProceedToPayment()">
                            <span *ngIf="!isLoadingMetodosPago">Continuar Compra</span>
                            <span *ngIf="isLoadingMetodosPago">Cargando...</span>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Payment Method View -->
            <div class="checkout-form payment-view" *ngIf="selectedMetodoPago">
                <div class="payment-method-selected">
                    <div class="payment-header">
                        <h2 class="section-title">Método de Pago: {{ selectedMetodoPago.nombre }}</h2>
                        <button (click)="returnToForms()" class="btn-return">
                            <svg xmlns="http://www.w3.org/2000/svg" class="icon" fill="none" viewBox="0 0 24 24"
                                stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                            </svg>
                            Retornar
                        </button>
                    </div>

                    <!-- PayPhone -->
                    <div *ngIf="selectedMetodoPago.nombre === 'PAYPHONE'" class="payment-content">
                        <div id="pp-button"></div>
                    </div>

                    <!-- Otros métodos -->
                    <div *ngIf="selectedMetodoPago.nombre !== 'PAYPHONE'" class="payment-content">
                        <div class="other-payment-placeholder">
                            <p class="placeholder-text">Aquí va el otro método</p>
                            <p class="placeholder-subtext">Método: {{ selectedMetodoPago.nombre }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Right Column: Summary + Ticket Forms -->
            <div class="order-right-column">
            <!-- Order Summary -->
            <div class="order-summary">
                <div class="summary-header">
                    <h2 class="section-title">Resumen de la Orden</h2>
                    <div *ngIf="timeRemaining && cartItems.length > 0" class="expiry-badge">
                        <svg xmlns="http://www.w3.org/2000/svg" class="expiry-icon" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <span>Expira en {{ timeRemaining }}</span>
                    </div>
                </div>

                <!-- Loading State -->
                <div *ngIf="isLoadingCart" class="loading-container">
                    <div class="spinner"></div>
                    <p class="loading-text">Cargando información del carrito...</p>
                </div>

                <!-- Content when loaded -->
                <ng-container *ngIf="!isLoadingCart">
                    <!-- Debug info -->
                    <!-- <div
                        style="background: #f0f0f0; padding: 1rem; margin-bottom: 1rem; font-size: 0.75rem; font-family: monospace;">
                        <p><strong>Debug Info:</strong></p>
                        <p>isLoadingCart: {{ isLoadingCart }}</p>
                        <p>cartItems.length: {{ cartItems.length }}</p>
                        <p>eventInfo exists: {{ !!eventInfo }}</p>
                        <p>totalAmount: {{ totalAmount }}</p>
                        <p>cartId: {{ cartId || 'null' }}</p>
                    </div> -->

                    <!-- No cart data message -->
                    <div *ngIf="!eventInfo && cartItems.length === 0" class="error-message-box">
                        <p class="error-title">⚠️ No se pudo cargar el carrito</p>
                        <p class="error-text">Revisa la consola del navegador para más detalles</p>
                    </div>

                    <!-- Event Info -->
                    <div *ngIf="eventInfo" class="event-info-card">
                        <div class="event-info-content">
                            <img *ngIf=" eventInfo.imagenes?.cuadrada" [src]=" eventInfo.imagenes?.cuadrada"
                                [alt]="eventInfo.nombre" class="event-image" />
                            <div class="event-details">
                                <h3 class="event-name">{{ eventInfo.nombre }}</h3>
                                <p class="event-location">{{ eventInfo.lugar }}</p>
                            </div>
                        </div>
                    </div>

                    <div class="cart-items-list">
                        <h3 class="items-title">Tickets ({{ cartItems.length }})</h3>

                        <div *ngIf="ticketGroups.length === 0" class="empty-cart-message">
                            <p>No hay tickets en el carrito</p>
                        </div>

                        <!-- Tickets agrupados -->
                        <div *ngFor="let group of ticketGroups" class="cart-item-detail">
                            <div class="item-info">
                                <h4 class="item-name">
                                    <span *ngIf="group.nombreSubevento">{{ group.nombreSubevento }}</span>
                                    <span *ngIf="!group.nombreSubevento">{{ group.nombreLocalidad || group.nombrePrecio }}</span>
                                </h4>
                                <p class="item-price-type" *ngIf="group.nombreSubevento && group.nombreLocalidad">{{ group.nombreLocalidad }}</p>
                                <p class="item-price-type" *ngIf="group.nombreLocalidad && !group.nombreSubevento">{{ group.nombrePrecio }}</p>
                                <p class="item-price-type" *ngIf="group.funcionFecha">
                                    📅 {{ group.funcionFecha }}<span *ngIf="group.funcionHora"> · 🕐 {{ group.funcionHora }}</span>
                                </p>
                                <p class="item-quantity">{{ group.nombrePrecio }}<span *ngIf="group.tipoprecio"> ({{ group.tipoprecio }})</span> · Cantidad: {{ group.cantidad }} x ${{
                                    group.precioBase.toFixed(2) }}</p>
                            </div>
                            <div class="item-price">
                                <p class="price-value">${{ (group.cantidad * group.precioBase).toFixed(2) }}</p>
                            </div>
                        </div>

                        <!-- Servicio de Emisión de Tickets -->
                        <div *ngIf="orderTotals.totalCargoServicio > 0" class="cart-item-detail service-item">
                            <div class="item-info">
                                <h4 class="item-name">{{ servicioEmisionLabel }}</h4>
                                <p class="item-quantity">Cantidad: {{ cartItems.length }} x ${{
                                    (orderTotals.totalCargoServicio / cartItems.length).toFixed(2) }}</p>
                            </div>
                            <div class="item-price">
                                <p class="price-value">${{ orderTotals.totalCargoServicio.toFixed(2) }}</p>
                            </div>
                        </div>

                        <!-- Servicio Administrativo -->
                        <div *ngIf="orderTotals.totalServicioAdministrativo > 0" class="cart-item-detail service-item">
                            <div class="item-info">
                                <h4 class="item-name">Servicio Administrativo</h4>
                                <p class="item-quantity">Cantidad: {{ cartItems.length }} x ${{
                                    (orderTotals.totalServicioAdministrativo / cartItems.length).toFixed(2) }}</p>
                            </div>
                            <div class="item-price">
                                <p class="price-value">${{ orderTotals.totalServicioAdministrativo.toFixed(2) }}</p>
                            </div>
                        </div>
                    </div>

                    <!-- Resumen detallado de totales -->
                    <div class="order-breakdown">
                        <!-- Mostrar subtotales por porcentaje de IVA desde sri_totales -->
                        <ng-container *ngIf="cartData?.sri_totales">
                            <div *ngFor="let sriItem of cartData.sri_totales" class="breakdown-row">
                                <span class="breakdown-label">Subtotal {{ sriItem.porcentaje }}%:</span>
                                <span class="breakdown-value">${{ sriItem.subtotal.toFixed(2) }}</span>
                            </div>
                        </ng-container>

                        <!-- Mostrar IVAs (solo si porcentaje > 0) -->
                        <ng-container *ngIf="cartData?.sri_totales">
                            <div *ngFor="let sriItem of cartData.sri_totales" class="breakdown-row">
                                <ng-container *ngIf="sriItem.porcentaje > 0">
                                    <span class="breakdown-label">IVA {{ sriItem.porcentaje }}%:</span>
                                    <span class="breakdown-value">${{ sriItem.iva.toFixed(2) }}</span>
                                </ng-container>
                            </div>
                        </ng-container>
                    </div>

                    <div class="order-total">
                        <span class="total-label">Total a Pagar:</span>
                        <span class="total-amount">${{ orderTotals.totalGeneral.toFixed(2) }}</span>
                    </div>

                    <!-- Comisión del método de pago (solo si hay método seleccionado) -->
                    <div *ngIf="selectedMetodoPago && porcentajeComision > 0" class="payment-commission-section">
                        <div class="commission-info">
                            <div class="commission-row">
                                <span class="commission-label">Método de pago: {{ selectedMetodoPago.nombre }}</span>
                            </div>
                            <div class="commission-row">
                                <span class="commission-label">Comisión ({{ porcentajeComision }}%):</span>
                                <span class="commission-value">${{ comisionMetodoPago.toFixed(2) }}</span>
                            </div>
                            <div class="commission-total">
                                <span class="total-with-commission-label">Total con comisión:</span>
                                <span class="total-with-commission-amount">${{ totalConComision.toFixed(2) }}</span>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>

            <!-- Formularios de tickets -->
            <div class="order-ticket-forms" *ngIf="!selectedMetodoPago">
                <div *ngIf="isLoadingForms" class="loading-forms-container">
                    <div class="spinner"></div>
                    <p class="loading-text">Cargando formularios...</p>
                </div>

                <div *ngIf="!isLoadingForms && eventoForms.length > 0" class="ticket-forms-section">
                    <h2 class="section-title">Información de Asistentes</h2>
                    <p class="section-description">Por favor, complete la información para cada ticket adquirido</p>

                    <!-- Formularios por cada ticket -->
                    <div *ngFor="let ticket of cartItems; let ticketIndex = index" class="ticket-form-card">
                        <div class="ticket-form-header">
                            <div class="ticket-form-title-block">
                                <h3 class="ticket-form-title">
                                    <span *ngIf="ticket.tipoticket?.subevento?.nombre">{{ ticket.tipoticket?.subevento?.nombre }} · </span>{{ (ticket.tipoticket?.nombre_localidad || '') + (ticket.tipoticket?.nombre_localidad ? ' · ' : '') + ticket.precioTipoTicket.nombre_precio }}<span *ngIf="ticket.precioTipoTicket.tipoprecio"> ({{ ticket.precioTipoTicket.tipoprecio }})</span> · Asiento #{{ ticket.secuencial }}
                                </h3>
                                <p *ngIf="ticket.tipoticket?.funcion?.fecha" class="ticket-form-subtitle">
                                    📅 {{ ticket.tipoticket?.funcion?.fecha }}<span *ngIf="ticket.tipoticket?.funcion?.hora"> · 🕐 {{ ticket.tipoticket?.funcion?.hora }}</span>
                                </p>
                            </div>
                            <div class="ticket-form-actions">
                                <button class="btn-change-price" (click)="openChangePriceModal(ticket)" title="Cambiar precio">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.5L16.732 3.732z" />
                                    </svg>
                                    Cambiar precio
                                </button>
                                <span class="ticket-form-status" 
                                      [class.status-complete]="isTicketFormValid(ticket.ticketid)"
                                      [class.status-incomplete]="!isTicketFormValid(ticket.ticketid)">
                                    {{ isTicketFormValid(ticket.ticketid) ? '✓ Completo' : '⚠ Incompleto' }}
                                </span>
                            </div>
                        </div>

                        <!-- Iteramos sobre cada formulario del evento -->
                        <div *ngFor="let eventoForm of eventoForms" class="form-template-section">
                            <h4 class="form-template-title">{{ eventoForm.templateForm.nombre }}</h4>
                            <!-- <p class="form-template-description" *ngIf="eventoForm.templateForm.descripcion">
                                {{ eventoForm.templateForm.descripcion }}
                            </p> -->

                            <div class="form-fields-grid">
                                <!-- Iteramos sobre cada campo del formulario -->
                                <div *ngFor="let field of eventoForm.templateForm.formfields" 
                                     class="form-field"
                                     [class.form-field-full]="field.type === 'textarea'">
                                    
                                    <label [for]="'field_' + ticket.ticketid + '_' + eventoForm.templateformid + '_' + field.name" 
                                           class="form-label">
                                        {{ field.label }}
                                        <span *ngIf="field.required" class="required-marker">*</span>
                                    </label>

                                    <!-- Campo de texto -->
                                    <input *ngIf="field.type === 'text'"
                                           [id]="'field_' + ticket.ticketid + '_' + eventoForm.templateformid + '_' + field.name"
                                           type="text"
                                           class="form-input"
                                           [placeholder]="field.placeholder || field.label"
                                           [ngModel]="getFieldValue(ticket.ticketid, eventoForm.templateformid, field.name)"
                                           (ngModelChange)="updateTicketFormField(ticket.ticketid, eventoForm.templateformid, field.name, $event)"
                                           [required]="field.required"
                                           [maxlength]="getFieldMaxLength(field, ticket.ticketid, eventoForm.templateformid)" />

                                    <!-- Campo de email -->
                                    <input *ngIf="field.type === 'email'"
                                           [id]="'field_' + ticket.ticketid + '_' + eventoForm.templateformid + '_' + field.name"
                                           type="email"
                                           class="form-input"
                                           [placeholder]="field.placeholder || field.label"
                                           [ngModel]="getFieldValue(ticket.ticketid, eventoForm.templateformid, field.name)"
                                           (ngModelChange)="updateTicketFormField(ticket.ticketid, eventoForm.templateformid, field.name, $event)"
                                           [required]="field.required"
                                           [maxlength]="getFieldMaxLength(field, ticket.ticketid, eventoForm.templateformid)" />

                                    <!-- Campo de teléfono -->
                                    <input *ngIf="field.type === 'tel'"
                                           [id]="'field_' + ticket.ticketid + '_' + eventoForm.templateformid + '_' + field.name"
                                           type="tel"
                                           class="form-input"
                                           [placeholder]="field.placeholder || field.label"
                                           [ngModel]="getFieldValue(ticket.ticketid, eventoForm.templateformid, field.name)"
                                           (ngModelChange)="updateTicketFormField(ticket.ticketid, eventoForm.templateformid, field.name, $event)"
                                           [required]="field.required"
                                           [maxlength]="getFieldMaxLength(field, ticket.ticketid, eventoForm.templateformid)" />

                                    <!-- Campo de número -->
                                    <input *ngIf="field.type === 'number'"
                                           [id]="'field_' + ticket.ticketid + '_' + eventoForm.templateformid + '_' + field.name"
                                           type="number"
                                           class="form-input"
                                           [class.input-error]="getFieldError(ticket.ticketid, eventoForm.templateformid, field)"
                                           [placeholder]="field.placeholder || field.label"
                                           [ngModel]="getFieldValue(ticket.ticketid, eventoForm.templateformid, field.name)"
                                           (ngModelChange)="updateTicketFormField(ticket.ticketid, eventoForm.templateformid, field.name, $event)"
                                           (input)="enforceNumberMaxLength($event, field, ticket.ticketid, eventoForm.templateformid)"
                                           [required]="field.required"
                                           [attr.min]="getFieldMin(field, ticket.ticketid, eventoForm.templateformid)"
                                           [attr.max]="getFieldMax(field, ticket.ticketid, eventoForm.templateformid)" />
                                    <p *ngIf="getFieldError(ticket.ticketid, eventoForm.templateformid, field)" class="field-error-text">
                                        {{ getFieldError(ticket.ticketid, eventoForm.templateformid, field) }}
                                    </p>

                                    <!-- Campo de fecha -->
                                    <input *ngIf="field.type === 'date'"
                                           [id]="'field_' + ticket.ticketid + '_' + eventoForm.templateformid + '_' + field.name"
                                           type="date"
                                           class="form-input"
                                           [ngModel]="getFieldValue(ticket.ticketid, eventoForm.templateformid, field.name)"
                                           (ngModelChange)="updateTicketFormField(ticket.ticketid, eventoForm.templateformid, field.name, $event)"
                                           [required]="field.required" />

                                    <!-- Campo de selección -->
                                    <select *ngIf="field.type === 'select'"
                                            [id]="'field_' + ticket.ticketid + '_' + eventoForm.templateformid + '_' + field.name"
                                            class="form-input"
                                            [ngModel]="getFieldValue(ticket.ticketid, eventoForm.templateformid, field.name)"
                                            (ngModelChange)="updateTicketFormField(ticket.ticketid, eventoForm.templateformid, field.name, $event)"
                                            [required]="field.required">
                                        <option value="" disabled>Seleccione una opción</option>
                                        <option *ngFor="let option of field.options" [value]="option">
                                            {{ option }}
                                        </option>
                                    </select>

                                    <!-- Campo de área de texto -->
                                    <textarea *ngIf="field.type === 'textarea'"
                                              [id]="'field_' + ticket.ticketid + '_' + eventoForm.templateformid + '_' + field.name"
                                              class="form-input"
                                              rows="4"
                                              [placeholder]="field.placeholder || field.label"
                                              [ngModel]="getFieldValue(ticket.ticketid, eventoForm.templateformid, field.name)"
                                              (ngModelChange)="updateTicketFormField(ticket.ticketid, eventoForm.templateformid, field.name, $event)"
                                              [required]="field.required"
                                              [maxlength]="getFieldMaxLength(field, ticket.ticketid, eventoForm.templateformid)"></textarea>

                                    <!-- Mensaje de ayuda si existe validación o helpText -->
                                    <p *ngIf="field.helpText || hasFieldConstraintHints(field, ticket.ticketid, eventoForm.templateformid)" 
                                       class="field-helper-text">
                                        <span *ngIf="field.helpText">{{ field.helpText }}</span>
                                        <span *ngIf="getFieldExactLengthHint(field, ticket.ticketid, eventoForm.templateformid) !== null">
                                            {{ getFieldExactLengthHint(field, ticket.ticketid, eventoForm.templateformid) }} caracteres.
                                        </span>
                                        <span *ngIf="getFieldMinLengthHint(field, ticket.ticketid, eventoForm.templateformid) !== null && getFieldExactLengthHint(field, ticket.ticketid, eventoForm.templateformid) === null">
                                            Mínimo {{ getFieldMinLengthHint(field, ticket.ticketid, eventoForm.templateformid) }} caracteres.
                                        </span>
                                        <span *ngIf="getFieldMaxLengthHint(field, ticket.ticketid, eventoForm.templateformid) !== null && getFieldExactLengthHint(field, ticket.ticketid, eventoForm.templateformid) === null">
                                            Máximo {{ getFieldMaxLengthHint(field, ticket.ticketid, eventoForm.templateformid) }} caracteres.
                                        </span>
                                        <span *ngIf="getFieldMin(field, ticket.ticketid, eventoForm.templateformid) !== null && getFieldMax(field, ticket.ticketid, eventoForm.templateformid) !== null">
                                            Rango: {{ getFieldMin(field, ticket.ticketid, eventoForm.templateformid) }} - {{ getFieldMax(field, ticket.ticketid, eventoForm.templateformid) }}
                                        </span>
                                        <span *ngIf="getFieldMin(field, ticket.ticketid, eventoForm.templateformid) !== null && getFieldMax(field, ticket.ticketid, eventoForm.templateformid) === null">
                                            Mínimo: {{ getFieldMin(field, ticket.ticketid, eventoForm.templateformid) }}
                                        </span>
                                        <span *ngIf="getFieldMax(field, ticket.ticketid, eventoForm.templateformid) !== null && getFieldMin(field, ticket.ticketid, eventoForm.templateformid) === null">
                                            Máximo: {{ getFieldMax(field, ticket.ticketid, eventoForm.templateformid) }}
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Mensaje de advertencia si hay formularios incompletos -->
                    <div *ngIf="!areAllTicketFormsValid()" class="incomplete-forms-warning">
                        <svg xmlns="http://www.w3.org/2000/svg" class="warning-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                        </svg>
                        <span>Por favor, complete toda la información de los asistentes antes de continuar.</span>
                    </div>
                </div>
            </div>
            </div><!-- end order-right-column -->
        </div>
    </div>
</div>

<!-- Modal Cambio de Precio -->
<div *ngIf="showChangePriceModal" class="modal-overlay" (click)="closeChangePriceModal()">
    <div class="modal-content change-price-modal" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <div>
                <h2 class="modal-title">Cambiar precio del boleto</h2>
                <p class="modal-subtitle" *ngIf="ticketForPriceChange">
                    {{ (ticketForPriceChange.tipoticket?.nombre_localidad || '') + (ticketForPriceChange.tipoticket?.nombre_localidad ? ' · ' : '') + ticketForPriceChange.precioTipoTicket.nombre_precio + ' · Boleto #' + ticketForPriceChange.secuencial }}
                </p>
            </div>
            <button (click)="closeChangePriceModal()" class="modal-close">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
        </div>
        <div class="modal-body">
            <div *ngIf="isLoadingPricesForChange" class="change-price-loading">
                <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-red-500"></div>
                <p>Cargando precios disponibles...</p>
            </div>
            <div *ngIf="!isLoadingPricesForChange && availablePricesForChange.length === 0">
                <p class="text-gray-500 text-sm">No hay precios disponibles.</p>
            </div>
            <div *ngIf="!isLoadingPricesForChange && availablePricesForChange.length > 0" class="change-price-grid">
                <div *ngFor="let precio of availablePricesForChange"
                     class="change-price-option"
                     [class.selected]="getPrecioId(selectedNewPrice) === getPrecioId(precio)"
                     [class.current]="getPrecioId(ticketForPriceChange?.precioTipoTicket) === getPrecioId(precio)"
                     (click)="selectedNewPrice = precio">
                    <div class="change-price-info">
                        <p class="change-price-name">{{ precio.nombre_precio }}</p>
                        <p class="change-price-currency">{{ precio.nombre_moneda }}</p>
                        <span class="current-badge" *ngIf="getPrecioId(ticketForPriceChange?.precioTipoTicket) === getPrecioId(precio)">Precio actual</span>
                    </div>
                    <p class="change-price-total">${{ precio.precio_total.toFixed(2) }}</p>
                    <div class="check-icon" *ngIf="getPrecioId(selectedNewPrice) === getPrecioId(precio)">
                        <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button class="btn-modal-cancel" (click)="closeChangePriceModal()" [disabled]="isChangingPrice">Cancelar</button>
            <button class="btn-confirm-price"
                    (click)="confirmPriceChange()"
                    [disabled]="!selectedNewPrice || isChangingPrice">
                <span *ngIf="isChangingPrice">Cambiando...</span>
                <span *ngIf="!isChangingPrice">Confirmar cambio</span>
            </button>
        </div>
    </div>
</div>

<!-- Modal de Métodos de Pago (fuera del contenedor principal) -->
<div *ngIf="showPaymentModal" class="modal-overlay" (click)="closePaymentModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <h2 class="modal-title">Seleccione Método de Pago</h2>
            <button (click)="closePaymentModal()" class="modal-close">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
        </div>
        <div class="modal-body">
            <div *ngIf="metodosPago.length === 0" class="no-payment-methods">
                <p>No hay métodos de pago disponibles</p>
            </div>
            <div *ngFor="let metodo of metodosPago" class="payment-method-card">
                <div class="payment-method-info">
                    <h3 class="payment-method-name">{{ metodo.nombre }}</h3>
                    <p class="payment-method-commission">
                        Comisión: {{ metodo.comision }}%
                        <span class="commission-amount" *ngIf="metodo.comision > 0 && orderTotals">
                            ({{ orderTotals.nombreMoneda || 'USD' }} {{ calculateComisionAmount(metodo.comision) | number:'1.2-2' }})
                        </span>
                    </p>
                    <p class="payment-total" *ngIf="metodo.comision > 0 && orderTotals && orderTotals.totalGeneral">
                        <strong>Total con comisión: {{ orderTotals.nombreMoneda || 'USD' }} {{ calculateTotalConComision(metodo.comision) | number:'1.2-2' }}</strong>
                    </p>
                </div>
                <button class="btn-select-payment" (click)="selectMetodoPago(metodo)">Seleccionar</button>
            </div>
        </div>
    </div>
</div>
